module.exports = __webpack_public_path__ + "0c1694466b538fdfb52484b77e8a24a6.png";